import * as React from "react";

import { Spinner } from "@replo/design-system/components/spinner/Spinner";
import { Tooltip } from "@replo/design-system/components/tooltip/Tooltip";
import { useStoreProductsFromDraftElement } from "@v1/hooks/useStoreProducts";
import { selectIsElementUpdateInProgressOrQueued } from "@v1/reducers/core-reducer";
import { useEditorSelector } from "@v1/store/store";

export const ElementUpdateLoadingIndicator = () => {
  const { isLoading: isFetchProductLoading } =
    useStoreProductsFromDraftElement();
  const elementUpdateInProgressOrQueued = useEditorSelector(
    selectIsElementUpdateInProgressOrQueued,
  );

  if (!elementUpdateInProgressOrQueued && !isFetchProductLoading) {
    return null;
  }

  return (
    <Tooltip
      triggerAsChild
      content={
        elementUpdateInProgressOrQueued
          ? "Saving your updates. Replo autosaves when you make changes."
          : "Loading product data from Shopify"
      }
    >
      <div tabIndex={-1}>
        <Spinner
          variant="primary"
          className="size-6"
          data-testid="pending-updates"
        />
      </div>
    </Tooltip>
  );
};
